import React from 'react';
import {AddButton} from '../../../components/button/AddButton';
import {TableHeader} from '../../../components/table/Headers';
import {Table} from '../../../components/table/Table';

export const EmployeeLevelTable = props => {
  const {
    route: {params},
    navigation,
  } = props;
  return (
    <Table
      eventSourceId={['employeelevel']}
      api={`/levels`}
      renderHeader={() => {
        return (
          <TableHeader
            title="Level Package Breakup"
            actions={[
              <AddButton
                title="Level Package Breakup"
                view="add-employee-level"
                params={params}
              />,
            ]}
          />
        );
      }}
      onRowPress={props => {
        const {row} = props;
        navigation.navigate(`edit-employee-level`, {
          row,
        });
      }}
      columns={[
        {
          type: 'text',
          header: 'Name',
          field: 'name',
        },
      ]}
    />
  );
};
